<template>
    <div>
        <Navbar />
        <div class="page-title-area">
            <div class="container">
                <div class="page-title-content">
                    <h1>Author: Anna Smith</h1>
                    <ul>
                        <li><router-link to="/">Home</router-link></li>
                        <li><router-link to="/blog-grid">Blog</router-link></li>
                        <li>Author</li>
                    </ul>
                </div>
            </div>
        </div>
        <BlogAuthor />
        <FooterStyleTwo />
    </div>
</template>

<script>
import Navbar from '../Layouts/Navbar'
import BlogAuthor from '../BlogAuthor/BlogAuthor'
import FooterStyleTwo from '../Layouts/FooterStyleTwo'

export default {
    name: 'BlogAuthorPage',
    components: {
        Navbar,
        BlogAuthor,
        FooterStyleTwo,
    }
}
</script>